class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('.header-search__mask-layer').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');

    const searchInput = this.querySelector('.search__input');
    searchInput.addEventListener(
      'input',
      this.checkViewAllResult
    )
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    this.checkViewAllResult();
    document.querySelector('.search__input').placeholder = "Start your search";
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    this.checkViewAllResult();
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  checkViewAllResult() {
    const interval = setInterval(() => {
      const viewAllElement = document.querySelector('.boost-pfs-search-suggestion-header-view-all a');

      if (viewAllElement) {
        const defaultText = viewAllElement.textContent;
        const viewAllCount = parseInt(defaultText.split(" ")[2]);
        if (viewAllCount > 0) {
          viewAllElement.textContent = `VIEW ALL RESULTS (${viewAllCount})`;
        }
        clearInterval(interval)
      }
    }, 100);
  }
}

customElements.define('details-modal', DetailsModal);
